import axios from '@/plugins/axios';
import { snackBarError, snackBarSuccess } from '@/utils/snackbar';

export default {
	async getMailbox({ commit }) {
		try {
			const { data } = await axios(`/mailbox`, { method: 'get' });
			const { mailBoxes } = data;
			commit('setMailBoxes', mailBoxes);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async save({ commit }, payload) {
		try {
			await axios(`/mailbox`, { method: 'post', data: payload });
			snackBarSuccess(`Petición enviada`)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async update({ commit, dispatch }, payload) {
		try {
			const id = payload._id;
			delete payload.__v;
			delete payload._id;
			delete payload.createdAt;
			delete payload.updatedAt;
			const { data } = await axios(`/mailbox/${id}`, { method: 'put', data: payload });
			await dispatch('getMailbox');
			return data.message.mailbox;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async deleteOne({ commit, dispatch }, id) {
		try {
			await axios(`/mailBox/${id}`, { method: 'delete' });
			await dispatch('getMailbox');
			snackBarSuccess('Eliminado')(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
};
